import { CookiesProvider } from "react-cookie";
import "bootstrap/dist/css/bootstrap.min.css";

export const wrapRootElement = ({ element }) => (
   <CookiesProvider>{element}</CookiesProvider>
);
